export const SUB_BRANCH_OVERALL_PERFORMANCE_FULL_YEAR = 'sub_branch_overall_performance_full_year';
export const SUB_BRANCH_OVERALL_COMPARISON_SPEND_TABLE =
  'sub_branch_overall_comparison_spend_table';
export const SUB_BRANCH_PERC_OPPS_TO_PLAN = 'sub_branch_perc_opps_to_plan';

export const PEFORMANCE_OVERVIEW_SUB_BRANCH_FILE_NAME = 'performance_overview_sub_branch.xlsx';
export const PEFORMANCE_OVERVIEW_OPPS_TO_PLAN_FILE_NAME = 'performance_overview_opps_to_plan.xlsx';
export const SUB_BRANCH_PERFORMANCE_OVERVIEW_DOWNLOAD_MENU = 'sub_branch_performance_overview';

export const errorMessages = {
  totalFailure: 'Some data could not be loaded. The table might be incomplete.',
  planDataErrorMessage: 'Plan data could not be loaded. Some columns might be incomplete.',
  comparisonDataErrorMessage:
    'Comparison data could not be loaded. The "% to Previous Year" column might be incomplete.',
  oppsToPlantData: 'Failed to load opportunities to plan data.',
};
